/** @format */

import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subject, takeUntil } from 'rxjs';
import { getIsLoadingData, getProfile, getProfilePicture } from './store';
import { State } from 'src/app/store';
import { Profile } from './models/profile';
import { DelayedAction, GetProfile, LoadStaticData, PruneManagedActiveUsers } from './store/application';
import { BrowserUtils } from '@azure/msal-browser';
import { MsalService } from '@azure/msal-angular';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	standalone: false,
})
export class AppComponent implements OnInit {
	profilePicture$: Observable<Blob | string | null>;
	profilePicture: Blob | string | null = null;

	profile$: Observable<Profile>;
	profile!: Profile;

	isLoadingData = true;
	isLoadingData$: Observable<boolean>;

	profileLoadInterval!: NodeJS.Timeout;
	isIframe = false;
	hasPrunedData = false;

	private ngUnsubscribe: Subject<void> = new Subject();

	constructor(private store$: Store<State>, private msalService: MsalService) {
		this.profilePicture$ = this.store$.select(getProfilePicture);
		this.profile$ = this.store$.select(getProfile);
		this.isLoadingData$ = this.store$.select(getIsLoadingData);
		this.isIframe = BrowserUtils.isInIframe();
	}

	ngOnInit(): void {
		this.isLoadingData$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((isLoadingData) => (this.isLoadingData = isLoadingData));
		this.profilePicture$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((profilePicture) => (this.profilePicture = profilePicture));

		this.profile$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((profile) => {
			this.profile = profile;
			if (this.profile.manage.length > 0 && !this.hasPrunedData) {
				this.hasPrunedData = true;
				const users = this.profile.manage.map((managed) => managed.user);
				this.store$.dispatch(PruneManagedActiveUsers({ users }));
			}
		});

		this.profileLoadInterval = setInterval(() => {
			if (this.msalService.instance && this.msalService.instance.getAllAccounts().length > 0) {
				this.store$.dispatch(LoadStaticData());
				// this.store$.dispatch(GetProfile({ skipUserActivation: false }));
				clearInterval(this.profileLoadInterval);
			}
		}, 50);
	}
}
